import type { SVGProps } from "react";
// generated from AlertFilled.svg — do not edit manually
// prettier-ignore
export default function AlertFilled(props: SVGProps<SVGSVGElement>) {
  return (<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <circle cx="12" cy="12" r="10" fill="currentColor"/>
  <path d="M12 7V13" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
  <circle cx="12" cy="16" r="1" fill="white"/>
</svg>);
}
